//footer accordion functionality for mobile screens
if(window.innerWidth < 990){
    if(document.querySelector(".footer_contact_heading")){
        document.querySelector(".contact_heading .icon_plus").addEventListener('click', ()=>{
            document.querySelectorAll(".contact_list li").forEach((li)=>{
                li.style.display = "flex";
            })
            document.querySelector(".contact_heading .icon_minus").style.display = "flex";
            document.querySelector(".contact_heading .icon_plus").style.display = "none";
        })
        document.querySelector(".contact_heading .icon_minus").addEventListener('click', ()=>{
            document.querySelectorAll(".contact_list li").forEach((li)=>{
                li.style.display = "none";
            })
            document.querySelector(".contact_heading .icon_plus").style.display = "flex";
            document.querySelector(".contact_heading .icon_minus").style.display = "none";
        })
    }
}


var email_contactboxdisplay = 0;
var address_contactboxdisplay = 0;
function showemailcontactbox(){
  if(window.innerWidth < 990){
        if(email_contactboxdisplay == 0){
            document.querySelectorAll(".contact_list .contactus-email").forEach((li)=>{
                li.style.display = "flex";
            })
            document.querySelector(".contact_heading .email_icon_minus").style.display = "flex";
            document.querySelector(".contact_heading .email_icon_plus").style.display = "none";
            email_contactboxdisplay = 1;
        }else{
            document.querySelectorAll(".contact_list .contactus-email").forEach((li)=>{
                li.style.display = "none";
            })
            document.querySelector(".contact_heading .email_icon_plus").style.display = "flex";
            document.querySelector(".contact_heading .email_icon_minus").style.display = "none";
            email_contactboxdisplay = 0;
        }
        
  }  
  
}

function showaddresscontactbox(){
  if(window.innerWidth < 990){
        if(address_contactboxdisplay == 0){
            document.querySelectorAll(".contact_list .contactus-address").forEach((li)=>{
                li.style.display = "flex";
            })
            document.querySelector(".contact_heading .address_icon_minus").style.display = "flex";
            document.querySelector(".contact_heading .address_icon_plus").style.display = "none";
            address_contactboxdisplay = 1;
        }else{
            document.querySelectorAll(".contact_list .contactus-address").forEach((li)=>{
                li.style.display = "none";
            })
            document.querySelector(".contact_heading .address_icon_plus").style.display = "flex";
            document.querySelector(".contact_heading .address_icon_minus").style.display = "none";
            address_contactboxdisplay = 0;
        }
        
  }  
  
}




document.addEventListener('DOMContentLoaded', function() {
    if (window.innerWidth < 990) {
        const contactHeading = document.querySelector(".contact_heading");
        
        if (contactHeading) {
            const iconPlus = contactHeading.querySelector(".icon_plus");
            const iconMinus = contactHeading.querySelector(".icon_minus");
            const contactListItems = document.querySelectorAll(".contact_list li");
            const emailIconPlus = contactHeading.querySelector(".email_icon_plus");
            const emailIconMinus = contactHeading.querySelector(".email_icon_minus");
            const emailContactBoxItems = document.querySelectorAll(".contact_list .contactus-email");
            const addressIconPlus = contactHeading.querySelector(".address_icon_plus");
            const addressIconMinus = contactHeading.querySelector(".address_icon_minus");
            const addressContactBoxItems = document.querySelectorAll(".contact_list .contactus-address");

            // General toggle function for showing and hiding list items
            function toggleItems(iconPlus, iconMinus, listItems) {
                if (iconPlus && iconMinus) {
                    if (iconPlus.style.display !== 'none') {
                        listItems.forEach((li) => li.style.display = "flex");
                        iconMinus.style.display = "flex";
                        iconPlus.style.display = "none";
                    } else {
                        listItems.forEach((li) => li.style.display = "none");
                        iconPlus.style.display = "flex";
                        iconMinus.style.display = "none";
                    }
                }
            }

            // Attach event listeners
            if (iconPlus || iconMinus) {
                iconPlus.addEventListener('click', () => toggleItems(iconPlus, iconMinus, contactListItems));
                iconMinus.addEventListener('click', () => toggleItems(iconPlus, iconMinus, contactListItems));
            }

            if (emailIconPlus || emailIconMinus) {
                emailIconPlus.addEventListener('click', () => toggleItems(emailIconPlus, emailIconMinus, emailContactBoxItems));
                emailIconMinus.addEventListener('click', () => toggleItems(emailIconPlus, emailIconMinus, emailContactBoxItems));
            }

            if (addressIconPlus || addressIconMinus) {
                addressIconPlus.addEventListener('click', () => toggleItems(addressIconPlus, addressIconMinus, addressContactBoxItems));
                addressIconMinus.addEventListener('click', () => toggleItems(addressIconPlus, addressIconMinus, addressContactBoxItems));
            }
        }
    }
});
